import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative mx-auto lg:w-1/2 border-2 border-red-900 bg-gray-50 shadow-xl rounded-xl p-8" }
const _hoisted_2 = { class: "text-3xl font-bold" }
const _hoisted_3 = { class: "mb-2 w300:block hidden" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = { class: "flex mb-5" }
const _hoisted_7 = { class: "flex-1 mr-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "absolute w-32 -bottom-6 right-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/converse.png",
    alt: "shoey"
  })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "absolute w-32 -bottom-6 right-32" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/air-shoey.png",
    alt: "shoey"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FarmerRewardDisplay = _resolveComponent("FarmerRewardDisplay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, "Your Staking Account is: " + _toDisplayString(_ctx.parseFarmerState(_ctx.farmerAcc)), 1),
    _createElementVNode("div", _hoisted_3, "Your identity: " + _toDisplayString(_ctx.farmerAcc?.identity.toBase58()), 1),
    _createElementVNode("div", _hoisted_4, "Associated vault: " + _toDisplayString(_ctx.farmerAcc?.vault.toBase58()), 1),
    _createElementVNode("div", _hoisted_5, "Items staked: " + _toDisplayString(_ctx.farmerAcc?.gemsStaked), 1),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_FarmerRewardDisplay, {
          key: _ctx.farmerAcc?.rewardA,
          farmReward: _ctx.farmAcc?.rewardA,
          reward: _ctx.farmerAcc?.rewardA,
          allGems: _ctx.farmAcc?.gemsStaked,
          yourGems: _ctx.farmerAcc?.gemsStaked,
          title: "$DUST Rewards"
        }, null, 8, ["farmReward", "reward", "allGems", "yourGems"])
      ])
    ]),
    _createElementVNode("button", {
      class: "bg-rb-mickeyred text-white rounded-lg py-2 px-3",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshFarmer && _ctx.refreshFarmer(...args)))
    }, " Refresh rewards "),
    _hoisted_8,
    _hoisted_9
  ]))
}